export default {
  active: "Ativo",
  inactive: "Inativo",
  undefined: "Indefinido",
};
